import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConst } from '../common/app.constants';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  get<T>(path: string, params: HttpParams = new HttpParams()): Observable<T> {
    return this.http.get<T>(AppConst.BASE_API + path, { params });
  }

  post<T>(path: string, body: Object = {}): Observable<T> {
    return this.http.post<T>(AppConst.BASE_API + path, body);
  }

  put<T>(path: string, body: Object = {}): Observable<T> {
    return this.http.put<T>(AppConst.BASE_API + path, body);
  }

  delete<T>(path: string): Observable<T> {
    return this.http.delete<T>(AppConst.BASE_API + path);
  }
}
